import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6e37e45c")

_pushScopeId("data-v-6e37e45c")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "a2a_dd",
  href: "https://www.addtoany.com/share"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.loaded && !_ctx.cordova)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", {
          class: "a2a_kit a2a_kit_size_32 a2a_default_style",
          "data-a2a-url": _ctx.toShareUrl
        }, [
          _createVNode("a", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ], 8, ["data-a2a-url"])
      ]))
    : (_ctx.loaded)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.share && _ctx.share(...args)))
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
})